import React, { useEffect, useState } from 'react';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-enterprise';
import { styledDefaultColDef } from '../../extras/cellRenderers';
import { getSessionsByEvent } from '../../services/apiService';
import moment from 'moment';

function SessionTypeBadge({ value }) {
  const isLive = value === 'Live';
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        padding: '2px 10px',
        borderRadius: 9999,
        fontSize: 11.5,
        fontWeight: 600,
        backgroundColor: isLive ? '#e0f2fe' : '#d1fae5',
        color: isLive ? '#0369a1' : '#065f46',
      }}
    >
      {value || '—'}
    </span>
  );
}

function ScheduleClassDetail({ event, onBack }) {
  const [rowData, setRowData] = useState([]);

  useEffect(() => {
    if (!event) return;
    const id = event.id || event.eventId;
    if (!id) return;
    getSessionsByEvent(id)
      .then((data) => {
        if (Array.isArray(data)) setRowData(data);
        else if (data && Array.isArray(data.data)) setRowData(data.data);
      })
      .catch(() => setRowData([]));
  }, [event]);

  const columnDefs = [
    { headerName: 'TOPIC', field: 'topic', flex: 2 },
    {
      headerName: 'SESSION TYPE',
      field: 'sessionType',
      flex: 1,
      cellRendererFramework: (params) => <SessionTypeBadge value={params.value} />,
    },
    { headerName: 'INSTRUCTOR NAME', field: 'instructorName', flex: 1 },
    { headerName: 'MODERATOR NAME', field: 'moderatorName', flex: 1 },
    {
      headerName: 'JOINING LINK',
      field: 'joiningLink',
      flex: 1,
      cellRendererFramework: (params) =>
        params.value ? (
          <a href={params.value} target="_blank" rel="noreferrer" style={{ color: '#4F46E5', fontSize: 13 }}>
            {params.value}
          </a>
        ) : (
          <span style={{ color: '#6B7280' }}>—</span>
        ),
    },
    { headerName: 'LESSON ID', field: 'lessonId', flex: 1 },
    {
      headerName: 'DATE',
      field: 'date',
      flex: 1,
      valueFormatter: (params) =>
        params.value ? moment(params.value).format('DD MMM YYYY') : '—',
    },
    {
      headerName: 'START TIME',
      field: 'startTime',
      flex: 1,
      valueFormatter: (params) =>
        params.value ? moment(params.value).format('h:mm a') : '—',
    },
    {
      headerName: 'END TIME',
      field: 'endTime',
      flex: 1,
      valueFormatter: (params) =>
        params.value ? moment(params.value).format('h:mm a') : '—',
    },
  ];

  return (
    <div>
      <button
        onClick={onBack}
        style={{
          background: 'none',
          border: 'none',
          color: '#4F46E5',
          fontSize: 13,
          fontWeight: 600,
          cursor: 'pointer',
          padding: 0,
          marginBottom: 16,
          display: 'flex',
          alignItems: 'center',
          gap: 4,
        }}
      >
        ← Back to Manage Classroom
      </button>

      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          marginBottom: 24,
        }}
      >
        <div>
          <h1 style={{ fontSize: 22, fontWeight: 700, color: '#111827', margin: 0 }}>
            {event?.eventName || '—'}
          </h1>
          <p style={{ fontSize: 13, color: '#6B7280', marginTop: 4, marginBottom: 0 }}>
            {event?.moduleName || ''}
          </p>
        </div>
        <button
          disabled
          style={{
            border: 'none',
            background: '#4F46E5',
            color: '#fff',
            borderRadius: 4,
            padding: '8px 20px',
            fontSize: 13,
            fontWeight: 600,
            cursor: 'not-allowed',
            opacity: 0.6,
          }}
        >
          Create Class
        </button>
      </div>

      <div
        style={{
          backgroundColor: '#fff',
          borderRadius: 16,
          border: '1px solid rgba(0,0,0,0.07)',
          boxShadow: '0 1px 6px rgba(0,0,0,0.05)',
          overflow: 'hidden',
        }}
      >
        <div className="ag-theme-alpine" style={{ width: '100%', height: 520 }}>
          <AgGridReact
            rowData={rowData}
            columnDefs={columnDefs}
            defaultColDef={styledDefaultColDef}
            rowHeight={48}
            headerHeight={44}
          />
        </div>
      </div>
    </div>
  );
}

export default ScheduleClassDetail;
